import Cookies from 'js-cookie';

function ConfirmEmailController($timeout, $route, $scope, $rootScope, $location,NextDrawSvc, ConfirmEmailSvc) {
  'ngInject';
  $scope.CountDownReady = false;

  $scope.TimeZones = [
    { DisplayName: "Dateline Standard Time", code: "DST" },
    { DisplayName: "UTC-11", code: "UTC-11" },
    { DisplayName: "Aleutian Standard Time", code: "HST" },
    { DisplayName: "Hawaiian Standard Time", code: "HST" },
    { DisplayName: "Marquesas Standard Time", code: "MIT" },
    { DisplayName: "Alaskan Standard Time", code: "AST" },
    { DisplayName: "UTC-09", code: "UTC-09" },
    { DisplayName: "Pacific Standard Time (Mexico)", code: "PST" },
    { DisplayName: "UTC-08", code: "UTC-08" },
    { DisplayName: "Pacific Standard Time", code: "PST" },
    { DisplayName: "US Mountain Standard Time", code: "UMST" },
    { DisplayName: "Mountain Standard Time (Mexico)", code: "MST" },
    { DisplayName: "Mountain Standard Time", code: "MST" },
    { DisplayName: "Central America Standard Time", code: "CAST" },
    { DisplayName: "Central Standard Time", code: "CST" },
    { DisplayName: "Easter Island Standard Time", code: "EAST" },
    { DisplayName: "Central Standard Time (Mexico)", code: "CST" },
    { DisplayName: "Canada Central Standard Time", code: "CCST" },
    { DisplayName: "SA Pacific Standard Time", code: "SPST" },
    { DisplayName: "Eastern Standard Time (Mexico)", code: "EST" },
    { DisplayName: "Eastern Standard Time", code: "EST" },
    { DisplayName: "Haiti Standard Time", code: "EST" },
    { DisplayName: "Cuba Standard Time", code: "CST" },
    { DisplayName: "US Eastern Standard Time", code: "EST" },
    { DisplayName: "Turks And Caicos Standard Time", code: "EST" },
    { DisplayName: "Paraguay Standard Time", code: "PST" },
    { DisplayName: "Atlantic Standard Time", code: "AST" },
    { DisplayName: "Venezuela Standard Time", code: "VST" },
    { DisplayName: "Central Brazilian Standard Time", code: "CBST" },
    { DisplayName: "SA Western Standard Time", code: "SWST" },
    { DisplayName: "Pacific SA Standard Time", code: "PSST" },
    { DisplayName: "Newfoundland Standard Time", code: "NST" },
    { DisplayName: "Tocantins Standard Time", code: "BRT" },
    { DisplayName: "E. South America Standard Time", code: "ESAST" },
    { DisplayName: "SA Eastern Standard Time", code: "SEST" },
    { DisplayName: "Argentina Standard Time", code: "AST" },
    { DisplayName: "Greenland Standard Time", code: "GST" },
    { DisplayName: "Montevideo Standard Time", code: "MST" },
    { DisplayName: "Magallanes Standard Time", code: "PHST" },
    { DisplayName: "Saint Pierre Standard Time", code: "PMST" },
    { DisplayName: "Bahia Standard Time", code: "BST" },
    { DisplayName: "UTC-02", code: "UTC-02" },
    { DisplayName: "Mid-Atlantic Standard Time", code: "MST" },
    { DisplayName: "Azores Standard Time", code: "AZOT" },
    { DisplayName: "Cape Verde Standard Time", code: "CVT" },
    { DisplayName: "UTC", code: "UTC" },
    { DisplayName: "GMT Standard Time", code: "GMT" },
    { DisplayName: "Greenwich Standard Time", code: "GMT" },
    { DisplayName: "Sao Tome Standard Time", code: "GMT" },
    { DisplayName: "Morocco Standard Time", code: "WEST" },
    { DisplayName: "W. Europe Standard Time", code: "CEST" },
    { DisplayName: "Central Europe Standard Time", code: "CEST" },
    { DisplayName: "Romance Standard Time", code: "CEST" },
    { DisplayName: "Central European Standard Time", code: "CET" },
    { DisplayName: "W. Central Africa Standard Time", code: "CAT" },
    { DisplayName: "Jordan Standard Time", code: "EEST" },
    { DisplayName: "GTB Standard Time", code: "EEST" },
    { DisplayName: "Middle East Standard Time", code: "MEST" },
    { DisplayName: "Egypt Standard Time", code: "EET" },
    { DisplayName: "E. Europe Standard Time", code: "EEST" },
    { DisplayName: "Syria Standard Time", code: "EEST" },
    { DisplayName: "West Bank Standard Time", code: "EEST" },
    { DisplayName: "South Africa Standard Time", code: "SAST" },
    { DisplayName: "FLE Standard Time", code: "EEST" },
    { DisplayName: "Israel Standard Time", code: "IST" },
    { DisplayName: "Kaliningrad Standard Time", code: "KALT" },
    { DisplayName: "Sudan Standard Time", code: "CAT" },
    { DisplayName: "Libya Standard Time", code: "EET" },
    { DisplayName: "Namibia Standard Time", code: "CAT" },
    { DisplayName: "Arabic Standard Time", code: "AST" },
    { DisplayName: "Turkey Standard Time", code: "TRT" },
    { DisplayName: "Arab Standard Time", code: "AST" },
    { DisplayName: "Belarus Standard Time", code: "MSK" },
    { DisplayName: "Russian Standard Time", code: "MSK" },
    { DisplayName: "E. Africa Standard Time", code: "EAT" },
    { DisplayName: "Iran Standard Time", code: "IRST" },
    { DisplayName: "Arabian Standard Time", code: "AST" },
    { DisplayName: "Astrakhan Standard Time", code: "MSK+1" },
    { DisplayName: "Azerbaijan Standard Time", code: "AZT" },
    { DisplayName: "Russia Time Zone 3", code: "SAMT" },
    { DisplayName: "Mauritius Standard Time", code: "MUT" },
    { DisplayName: "Saratov Standard Time", code: "MSK+1" },
    { DisplayName: "Georgian Standard Time", code: "GET" },
    { DisplayName: "Volgograd Standard Time", code: "VOLT" },
    { DisplayName: "Caucasus Standard Time", code: "AMT" },
    { DisplayName: "Afghanistan Standard Time", code: "AFT" },
    { DisplayName: "West Asia Standard Time", code: "TMT" },
    { DisplayName: "Ekaterinburg Standard Time", code: "YEKT" },
    { DisplayName: "Pakistan Standard Time", code: "PKT" },
    { DisplayName: "Qyzylorda Standard Time", code: "QYZT" },
    { DisplayName: "India Standard Time", code: "IST" },
    { DisplayName: "Sri Lanka Standard Time", code: "SLST" },
    { DisplayName: "Nepal Standard Time", code: "NPT" },
    { DisplayName: "Central Asia Standard Time", code: "ALMT" },
    { DisplayName: "Bangladesh Standard Time", code: "BST" },
    { DisplayName: "Omsk Standard Time", code: "OMST" },
    { DisplayName: "Myanmar Standard Time", code: "MMT" },
    { DisplayName: "SE Asia Standard Time", code: "ICT" },
    { DisplayName: "Altai Standard Time", code: "KRAT" },
    { DisplayName: "W. Mongolia Standard Time", code: "HOVT" },
    { DisplayName: "North Asia Standard Time", code: "KRAT" },
    { DisplayName: "N. Central Asia Standard Time", code: "NOVT" },
    { DisplayName: "Tomsk Standard Time", code: "MSK+4" },
    { DisplayName: "China Standard Time", code: "CST" },
    { DisplayName: "North Asia East Standard Time", code: "IRKT" },
    { DisplayName: "Singapore Standard Time", code: "SST" },
    { DisplayName: "W. Australia Standard Time", code: "AWST" },
    { DisplayName: "Taipei Standard Time", code: "CST" },
    { DisplayName: "Ulaanbaatar Standard Time", code: "ULAT" },
    { DisplayName: "Aus Central W. Standard Time", code: "ACWST" },
    { DisplayName: "Transbaikal Standard Time", code: "TST" },
    { DisplayName: "Tokyo Standard Time", code: "JST" },
    { DisplayName: "North Korea Standard Time", code: "PYT" },
    { DisplayName: "Korea Standard Time", code: "KST" },
    { DisplayName: "Yakutsk Standard Time", code: "YAKT" },
    { DisplayName: "Cen. Australia Standard Time", code: "ACWST" },
    { DisplayName: "AUS Central Standard Time", code: "ACWST" },
    { DisplayName: "E. Australia Standard Time", code: "AEST" },
    { DisplayName: "AUS Eastern Standard Time", code: "AEST" },
    { DisplayName: "West Pacific Standard Time", code: "PST" },
    { DisplayName: "Tasmania Standard Time", code: "AEST" },
    { DisplayName: "Vladivostok Standard Time", code: "VLAT" },
    { DisplayName: "Lord Howe Standard Time", code: "LHST" },
    { DisplayName: "Bougainville Standard Time", code: "BST" },
    { DisplayName: "Russia Time Zone 10", code: "SRET" },
    { DisplayName: "Magadan Standard Time", code: "MAGT" },
    { DisplayName: "Norfolk Standard Time", code: "NFT" },
    { DisplayName: "Sakhalin Standard Time", code: "SAKT" },
    { DisplayName: "Central Pacific Standard Time", code: "SBT" },
    { DisplayName: "Russia Time Zone 11", code: "PETT" },
    { DisplayName: "New Zealand Standard Time", code: "NZST" },
    { DisplayName: "UTC+12", code: "UTC" },
    { DisplayName: "Fiji Standard Time", code: "FJT" },
    { DisplayName: "Kamchatka Standard Time", code: "PETT" },
    { DisplayName: "Chatham Islands Standard Time", code: "CHAST" },
    { DisplayName: "UTC+13", code: "UTC" },
    { DisplayName: "Tonga Standard Time", code: "TOT" },
    { DisplayName: "Samoa Standard Time", code: "SST" },
    { DisplayName: "Line Islands Standard Time", code: "LINT" }
  ]

  jQuery(document).ready(function ($) {
      //Check for auth token
      if (Cookies.get('TLF_Auth_Token') !== undefined) {
          //ConfirmEmailSvc.get({ APIKey: Cookies.get('TLF_Auth_Token') }, function (data) {
          //    $timeout(function() {
          //        $rootScope.Loggedin = true;
          //        $scope.User = data;
          //    });
          //});
      } else {
          var date = new Date();
          var minutes = 60000;
          date.setTime(date.getTime() + (minutes * 60 * 1000));
          Cookies.set('TLF_LastPage', $location.$$path, { expires: date });
          $location.path('/connect').replace();
          $route.reload();
      }
      if (Cookies.get('Member_Id') !== undefined) {
          ConfirmEmailSvc.get({ Email: Cookies.get('Email'), MemberId: Cookies.get('Member_Id') }, function (data) {
              //$timeout(function() {
              //    $rootScope.Loggedin = true;
              //    $scope.User = data;
              //});
          });
      } else {
          var date = new Date();
          var minutes = 60000;
          date.setTime(date.getTime() + (minutes * 60 * 1000));
          Cookies.set('TLF_LastPage', $location.$$path, { expires: date });
          $location.path('/connect').replace();
          $route.reload();
      }
  });

  //Display confirmed email modal.
  jQuery(document).ready(function ($) {
      $('#modal').show();
      $('#email-confirmed').fadeIn(500);
      window.history.replaceState(null, "", "/");
  });


  Date.prototype.addHours = function (h) {
      this.setTime(this.getTime() + (h * 60 * 60 * 1000));
      return this;
  }

  $scope.NextDraw = {};
  NextDrawSvc.get({}, function (data) {
      $scope.NextDraw = data;
      var now = new Date();
      var date = new Date(Date.parse($scope.NextDraw.NextDrawDate) + now.getTimezoneOffset() * 60000);

      jQuery(document).ready(function ($) {
          for (var i = 0; i < $scope.TimeZones.length; i++) {
              if ($scope.TimeZones[i].DisplayName == $scope.NextDraw.TimeZone) {
                  $scope.TimeZone = $scope.TimeZones[i].code
              }
          }
          $scope.DrawTime = $scope.NextDraw.NextDrawTime

          if ($scope.SelectedLanguage === 'fr') {
              $scope.TimerLabels = [{ Days: "Jours", Hours: "Heures", Minutes: "Minutes", Seconds: "Secondes" }];
          } else if ($scope.SelectedLanguage === 'es') {
              $scope.TimerLabels = [{ Days: "D&igrave;as", Hours: "Horas", Minutes: "Minutos", Seconds: "Segundos" }];
          } else {
              $scope.TimerLabels = [{ Days: "Days", Hours: "Hours", Minutes: "Minutes", Seconds: "Seconds" }];
          }

          var countDownDate = new Date($scope.NextDraw.NextDrawDate)
          var currentDate = new Date();
          var utc_now = new Date(currentDate.getUTCFullYear(), currentDate.getUTCMonth(), currentDate.getUTCDate(), currentDate.getUTCHours(), currentDate.getUTCMinutes(), currentDate.getUTCSeconds(), currentDate.getUTCMilliseconds());
          var now = utc_now.getTime()

          now += ($scope.NextDraw.UTCOffset * 60 * 60 * 1000)
          var distance = countDownDate - now;

          // Time calculations for days, hours, minutes and seconds
          var days = Math.floor(distance / (1000 * 60 * 60 * 24));
          var hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
          var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
          var seconds = Math.floor((distance % (1000 * 60)) / 1000);

          if (document.getElementById("countdown") !== null) {
              document.getElementById("countdown").innerHTML = '<table translate-cloak style="width:100%"><tr><th>' + $scope.TimerLabels[0].Days + '</th><th>' + $scope.TimerLabels[0].Hours + '</th><th>' + $scope.TimerLabels[0].Minutes + '</th><th>' + $scope.TimerLabels[0].Seconds + '</th></tr><tr><td>' + days + '</td><td>' + hours + '</td><td>' + minutes + '</td><td>' + seconds + '</td></tr></table>'
              document.getElementById("countdown").classList.remove("countdownTable")
          }
          if (document.getElementById("countdown-mobile") !== null) {
              document.getElementById("countdown-mobile").innerHTML = '<table translate-cloak style="width:100%"><tr><th>' + $scope.TimerLabels[0].Days + '</th><th>' + $scope.TimerLabels[0].Hours + '</th><th>' + $scope.TimerLabels[0].Minutes + '</th><th>' + $scope.TimerLabels[0].Seconds + '</th></tr><tr><td>' + days + '</td><td>' + hours + '</td><td>' + minutes + '</td><td>' + seconds + '</td></tr></table>'
              document.getElementById("countdown-mobile").classList.remove("countdownTable")
          }
      });
  });
};

export default {
  name: 'confirmemailCTRL',
  fn: ConfirmEmailController
};